<ng-template class="alias-main" #showModalContent>
  <div class="alias-list-section">
    <div class="alias">
      <div class="user-name">@if (aliasList) {
        <p>{{'BP_PM_LP_HI'| translate }} {{username}}</p>
        } @if (!aliasList) {
        <p class="mt">
          <ngx-skeleton-loader class="height" animation="pulse"
            [theme]="{width: '10em', height: '0.5em','background-color': '#4b4b4b', 'animation-duration': '1s' }"></ngx-skeleton-loader>
        </p>
        }
      </div>
      <h4>{{'BP_PM_LP_SB' | translate}}</h4>
      <p>{{ 'BP_PM_LP_PD' | translate}}</p>
    </div>

    @if (userData) {
    <div class="list">
      <ul>
        @for (item of aliasList; track item; let i = $index) {
        <li role="button" (click)="aliasSelected(i)">
          <div>
            <span class="dp" alt="">
              <img [src]="item.profileImageUrl" alt="">
            </span>
            <p>{{ item.profileName }}</p>
          </div>
          <span class="right-arrow"></span>
        </li>
        }
      </ul>
    </div>
    }
    @if (!userData) {
    <div class="list">
      <ul>
        @for (_ of [].constructor(2); track _) {
        <li class="loader-list">
          <div>
            <span class="dp" alt=""></span>
            <p class="mt_1"><ngx-skeleton-loader class="height" animation="pulse"
                [theme]="{width: '8.75em', height: '0.5em','background-color': '#4b4b4b', 'animation-duration': '1s' }"></ngx-skeleton-loader>
            </p>
            <span class="right-arrow"></span>
          </div>
        </li>
        }
      </ul>
    </div>
    }

    @if (userData) {
    <div>
      @if (!aliasList || aliasList.length === 0) {
      <app-access-denied></app-access-denied>
      }
    </div>
    }
  </div>
</ng-template>


@if (showModal) {
<app-common-modal [isHeaderVisible]="isHeaderVisible" [isFooterVisible]="false" [component]="component"
  [showModalContent]="showModalContent" [isCloseModal]="isCloseModal" [type]="type"></app-common-modal>
}